<template>
  <div
    class="kpb-flex"
    :style="`--kpb-flex-direction: ${flexDirection}; --kpb-flex-wrap: ${flexWrap}; --kpb-flex-justify-content: ${justifyContent}; --kpb-flex-align-items: ${alignItems}; --kpb-flex-align-content: ${alignContent}; --kpb-flex-gap: ${gap}`"
  >
    <slot />
  </div>
</template>

<script>
/** Layout component for flexing content. */
export default {
  props: {
    flexDirection: {
      type: String,
      default: 'row',
    },
    flexWrap: {
      type: String,
      default: 'nowrap',
    },
    justifyContent: {
      type: String,
      default: 'flex-start',
    },
    alignItems: {
      type: String,
      default: 'stretch',
    },
    gap: {
      type: String,
      default: '1rem',
    },
    alignContent: {
      type: String,
    },
  },
}
</script>

<style lang="scss">
.kpb-flex {
  display: flex;

  flex-direction: var(--kpb-flex-direction);
  flex-wrap: var(--kpb-flex-wrap);
  justify-content: var(--kpb-flex-justify-content);
  align-items: var(--kpb-flex-align-items);
  align-content: var(--kpb-flex-align-content);
  gap: var(--kpb-flex-gap);

  @include respond-below('phone') {
    flex-direction: column;
  }
}
</style>
